import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SportCompetitionsListWrapper } from './SportCompetitionsList.style';
import { TableSportsRowLink } from 'src/ui/components/table/sports/row/link/TableSportsRowLinkUnified';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { useCommon } from 'src/domains/common/Common';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    EventsTableInfo,
    InfoIconUnifiedWrapper,
} from 'src/domains/sportsbook/webview/components/sportEventsListNew/EventsTableMobX.style';
import { EventsTableMarketsLoader } from 'src/domains/sportsbook/webview/components/loaders/EventsTableMarketsLoader';
import { InfoIconUnified } from 'src/domains/layouts/shared/assets/icons/InfoIconUnified';
import { SectionHeader } from 'src/ui/components/collapse/sports/05/SectionHeader';
import { getSimpleDate } from 'src/utils/date';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { UnifiedSportEventsListState } from 'src/domains/sportsbook/state/eventsListState/unifiedSportEventsListState/UnifiedSportEventsListState';
import { EventsCollectionQueryCompetitionType } from 'src_common/common/websocket2/models/EventsCollectionQueryModel';

interface SportCompetitionsListPropsType {
    sportId: string;
    sportWideListState: UnifiedSportEventsListState;
    label?: string;
    isOutrights?: boolean;
}

export const SportCompetitionsList = observer('SportCompetitionsList', (props: SportCompetitionsListPropsType) => {
    const { label, sportId, isOutrights = false, sportWideListState } = props;
    const common = useCommon();
    const starRouter = StarRouter.get(common);

    if (sportWideListState.isLoading) {
        return <EventsTableMarketsLoader />;
    }

    const competitions: Array<
        EventsCollectionQueryCompetitionType & {
            flagCode: string;
            startTime?: number;
        }
    > = isOutrights ? sportWideListState.outrightsForListView : sportWideListState.competitionsForListView;

    return (
        <SportCompetitionsListWrapper data-testid='sport-competitions-list'>
            {label ? (
                label.toLowerCase().includes('all') && sportId === 'golf' ? null : (
                    <SectionHeader
                        title={label}
                        dataTest='sport-competitions-list-header'
                    />
                )
            ) : null}
            {competitions.length > 0 ? (
                competitions.map((competition) => {
                    const formattedDate = competition.startTime
                        ? getSimpleDate(new Date(competition.startTime).toISOString(), LanguagesState.get(common))
                        : '';
                    const handleClick = (): void => {
                        starRouter.redirectToCompetitionPage(
                            competition.id,
                            sportId,
                            isOutrights === true ? { filter: 'outrights' } : undefined
                        );
                    };

                    const dataTest = isOutrights
                        ? `outrights-event-row-${competition.id}`
                        : `sport-competition-row-${competition.id}`;

                    return (
                        <TableSportsRowLink
                            key={competition.id}
                            dataTest={dataTest}
                            flagCode={competition.flagCode}
                            label={competition.name}
                            formattedDate={formattedDate}
                            handleClick={handleClick}
                        />
                    );
                })
            ) : (
                <EventsTableInfo>
                    <InfoIconUnifiedWrapper>
                        <InfoIconUnified />
                    </InfoIconUnifiedWrapper>
                    {isOutrights ? (
                        <I18n
                            langKey='events.table.outrights.empty'
                            defaultText='No outrights Available'
                        />
                    ) : (
                        <I18n
                            langKey='events.table.competitions.empty'
                            defaultText="Sorry, we haven't found any competitions for this sport."
                        />
                    )}
                </EventsTableInfo>
            )}
        </SportCompetitionsListWrapper>
    );
});
